import { Box } from "@mui/material";

const LanguageFlag = ({ language, sx = {} }) => {
  const languageFlags = {
    en: "fi fi-us fis",
    es: "fi fi-es fis",
  };

  const flagClass = languageFlags[language] || languageFlags.en;

  return (
    <Box
      component="span"
      className={flagClass}
      sx={{
        fontSize: 18,
        borderRadius: "50%",
        display: "inline-block",
        ...sx,
      }}
    />
  );
};

export default LanguageFlag;
